import React from 'react'
import { observer } from 'mobx-react'
import makeStyles from '@mui/styles/makeStyles'

import { Divider, Typography } from '@mui/material'

import { useStores } from 'admin/hooks'
import { formatDateHourAmPm } from 'admin/utils/helper'
import InfoSection from 'admin/components/info-section'
import HeaderBar from 'admin/components/head-bar'

import styles from './styles'

const useStyles = makeStyles(styles)

const TransferRequestInfo = () => {
  const classes = useStyles()
  const { infoSectionStore } = useStores()

  const { selected } = infoSectionStore

  const details = [
    {
      title: 'Description',
      data: selected?.description,
    },
    {
      title: 'Transaction Date',
      data: formatDateHourAmPm(selected?.createdAt),
    },
    {
      title: 'Transaction Type',
      data: selected?.transactionType,
    },
    {
      title: 'Payment Method',
      data: selected?.paymentMethodType,
    },
    {
      title: 'Currency',
      data: selected?.currency,
    },
    {
      title: 'Expired date',
      data: formatDateHourAmPm(selected?.expiredAt),
    },
  ]

  return (
    <InfoSection title="Transfer Request">
      {selected && (
        <>
          <div className={classes.headbar}>
            <HeaderBar
              data={[
                {
                  label: 'Reference ID',
                  value: selected?.referenceId,
                },
                {
                  label: 'Amount',
                  value: `$${Number(selected?.amount).toFixed(2) || '0.00'}`,
                },
              ]}
            />
          </div>
          <Divider />
          <Typography
            variant="h4"
            className={classes.title}
          >
            Details
          </Typography>
          <div className={classes.details}>
            {details.map((item) => (
              <div
                key={item.title}
                className={classes.info}
              >
                <Typography
                  variant="h4"
                  className={classes.titleLabel}
                >
                  {item.title}
                </Typography>
                <Typography>{item.data}</Typography>
              </div>
            ))}
          </div>
        </>
      )}
    </InfoSection>
  )
}

export default observer(TransferRequestInfo)
